module.exports = __webpack_public_path__ + "img/carlo-rossi.9aba2cb4.png";